<template>
  <section>
    <Feature v-if="isMutiple" :title="$t('GROUP_KEY')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="[$t('TOTAL') + ': ' + quotationList.length]" :fieldWidthArr="[364]"
        :fieldSpanWidthArr="[102]">
        <Select class="Select" slot="a" v-model="formNo" @on-change="changeFormNo" style="width: 200px">
          <Option v-for="(item, index) in quotationList" :value="item.formNo" :key="index">{{ item.formNo }}</Option>
        </Select>
      </FormRowTwo>
    </Feature>
    <Feature :title="$t('MATERIAL_BASIC_INFORMATION')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo
        :fieldNameArr="[$t('FORM_NO') + ': ', $t('RFQ_TYPE') + ': ', $t('VENDOR_CODE') + ': ', $t('PLANT_CODE') + ': ', $t('VENDOR_PN') + ': ']"
        :fieldWidthArr="[364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102]">
        <Input class="Input" v-model="quotation.formNo" slot="a" disabled />
        <Input class="Input" v-model="rfqType" slot="b" disabled />
        <Input class="Input" v-model="quotation.vendorCode" slot="c" disabled />
        <Input class="Input" v-model="quotation.plant" slot="d" disabled />
        <Input class="Input" v-model="quotation.vendorPart" slot="e" disabled />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('CURRENCY') + ': ', $t('DELTA_PN') + ': ', $t('DESCRIPTION') + ': ', $t('REMARK') + ': ']"
        :fieldWidthArr="[364, 364, 728, 728]" :fieldSpanWidthArr="[102, 102, 102, 102]">
        <Input class="Input" v-model="quotation.currency" slot="a" disabled />
        <Input class="Input" v-model="quotation.deltaPart" slot="b" disabled />
        <Input style="width: 612px" v-model="quotation.deltaPartDesc" type="textarea" slot="c" disabled :rows="1" />
        <Input style="width: 612px" v-model="quotation.ymgrRemark" type="textarea" slot="d" disabled :rows="1" />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('CATEGORY') + ': ']" :fieldWidthArr="[362]" :fieldSpanWidthArr="[100]">
        <Input class="Input" value="PWB" slot="a" disabled />
      </FormRowTwo>
      <FormRowTwo v-if="quotationDocumentView" :fieldNameArr="[$t('PART_SPECIFICATION') + ': ']">
      </FormRowTwo>
      <PLMDocument v-if="quotationDocumentView" :plmQuotationDocuments="plmQuotationDocuments"
        :quotationUuid="quotation.uuid"></PLMDocument>
    </Feature>

    <Feature :title="$t('BUYER')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="[$t('DELTA_BUYER_NAME') + ': ', $t('TARGET_PRICE') + ': ', $t('EMAIL') + ': ']"
        :fieldWidthArr="[364, 364, 728]" :fieldSpanWidthArr="[102, 102, 102]">
        <Input class="Input" v-model="cpcAccountName" slot="a" disabled />
        <Input class="Input" v-model="quotation.targetPrice" slot="b" disabled />
        <Input style="width: 612px" v-model="quotation.cpcAccountConstactEmail" type="textarea" slot="c" disabled
          :rows="1" />
      </FormRowTwo>

      <FormRowTwo v-show="hasComments" :fieldNameArr="[$t('COMMENTS') + ': ']" :fieldWidthArr="[364]"
        :fieldSpanWidthArr="[102]">
        <Button class="Input" icon="ios-create" slot="a" @click="openComments">{{ $t('COMMENTS') }}</Button>
      </FormRowTwo>

      <FormRowTwo v-if="cpcToVendorAttachmentsExited" :fieldNameArr="[$t('REFERENCE_FILE')]">
      </FormRowTwo>
      <FormRowTwo v-if="cpcToVendorAttachmentsExited" :fieldNameArr="[$t('')]">
        <Table width="600" border :columns="fileSchemaList" :data="cpcToVendorAttachments" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRowTwo>
    </Feature>

    <Feature :title="$t('QUOTATION')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo
        :fieldNameArr="[$t('QUOTE_DATE') + ': ', $t('MODEL') + ': ', $t('DELTA_EXCHANGE_RATE') + ': ', $t('CPC_EXCHANGE_RATE') + ': ', 'RFQ Base' + ': ']"
        :fieldWidthArr="[364, 364, 444, 444, 666]" :fieldSpanWidthArr="[102, 102, 182, 182, 102]">
        <Input class="Input" v-model="today" slot="a" :disabled="true" />
        <Input class="Input" v-model="pwbQuotation.deltaModel" slot="b" :disabled="!quotation.editable" />
        <Input class="Input" v-model="deltaExchangeRate" slot="c" :disabled="true" />
        <Input class="Input" v-model="cpcExchangeRate" slot="d" :disabled="!quotation.editable"
          style="border-color:red;border-width:1px;border-style:solid;" />
        <RadioGroup v-model="pwbQuotation.rfqBase" size="large" slot="e" @on-change="changeRfqBase()">
          <Radio label="SHEET_BASE" :disabled="!quotation.editable">{{ $t('SHEET_BASE') }}</Radio>
          <Radio label="ACTUAL_PANEL_BASE" :disabled="!quotation.editable">{{ $t('ACTUAL_PANEL_BASE') }}</Radio>
        </RadioGroup>
      </FormRowTwo>
    </Feature>

    <Feature v-if="showStepTwo" :title="$t('CCL_FIELD')" :iconClass="'fa-pencil-square-o'">
      <Card :title="$t('PWB_CASE_ATTRIBUTES')" class="card-info">
        <FormRowTwo :fieldNameArr="[$t('CCL_LAMINATE_TYPE') + ': ']" :fieldWidthArr="[414]" :fieldSpanWidthArr="[152]">
          <Select class="Select" style="border-color:red;border-width:1px;border-style:solid;"
            v-model="pwbQuotation.cclLaminateType" @on-change="chagneCclLaminateType($event)" :placeholder="$t('CHOOSE')"
            slot="a">
            <Option v-for="(item) in cclLaminateTypes" :value="item" :key="item">
              {{ item }}
            </Option>
          </Select>
        </FormRowTwo>
        <FormRowTwo
          :fieldNameArr="[$t('LAYER') + ': ', $t('PCB_THICKNESS') + ': ', $t('TG') + ': ', $t('EXTERNAL_COPPER_THICKNESS_TITLE') + ': ', $t('INTERNAL_COPPER_THICKNESS_TITLE') + ': ', $t('INTERNAL_CORE_THICKNESS_TITLE') + ': ']"
          :fieldWidthArr="[414, 414, 414, 414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152, 152, 152, 152]">
          <Select class="Select" style="border-color:red;border-width:1px;border-style:solid;"
            v-model="pwbQuotation.layer" @on-change="searchPcbLayer()" :placeholder="$t('CHOOSE')" slot="a">
            <Option v-for="(item) in layers" :value="item" :key="item">
              L{{ item }}
            </Option>
          </Select>
          <Select class="Select" style="border-color:red;border-width:1px;border-style:solid;"
            v-model="pwbQuotation.pcbThickness" @on-change="updatePcbMaster()" :placeholder="$t('CHOOSE')" slot="b">
            <Option v-for="(item) in pcbThicknesses" :value="item" :key="item">
              {{ item }} (mm)
            </Option>
          </Select>
          <Select class="Select" style="border-color:red;border-width:1px;border-style:solid;" v-model="pwbQuotation.tg"
            @on-change="updatePcbMaster()" :placeholder="$t('CHOOSE')" slot="c">
            <Option v-for="(item) in tgs" :value="item" :key="item">
              {{ item }}
            </Option>
          </Select>
          <Select class="Select" style="border-color:red;border-width:1px;border-style:solid;"
            v-model="pwbQuotation.externalCopperThickness" @on-change="updatePcbMaster()" :placeholder="$t('CHOOSE')"
            slot="d">
            <Option v-for="(item) in externalCopperThicknesses" :value="item" :key="item">
              {{ item }} (oz)
            </Option>
          </Select>
          <Select class="Select" style="border-color:red;border-width:1px;border-style:solid;"
            v-model="pwbQuotation.internalCopperThickness" @on-change="updatePcbMaster()" :placeholder="$t('CHOOSE')"
            slot="e">
            <Option v-for="(item) in internalCopperThicknesses" :value="item" :key="item">
              {{ item }} (oz)
            </Option>
          </Select>
          <Select class="Select" style="border-color:red;border-width:1px;border-style:solid;"
            v-model="pwbQuotation.internalCoreThickness" @on-change="updatePcbMaster()" :placeholder="$t('CHOOSE')"
            slot="f">
            <Option v-for="(item) in internalCoreThicknesses" :value="item" :key="item">
              {{ item }} (mm)
            </Option>
          </Select>
        </FormRowTwo>
        <FormRowTwo
          :fieldNameArr="[$t('MAIN_CCL_SUPPLIER') + ': ', $t('MAIN_CCL_UL_NUMBER') + ': ', $t('MAIN_CORE_UP') + ': ', $t('MAIN_SOURCE_CCL_SHARE') + ': ']"
          :fieldWidthArr="[414, 414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152, 152]">
          <Select class="Select" style="border-color:red;border-width:1px;border-style:solid;"
            v-model="mainSourceCclSupplier" @on-change="changeMainCclSupplier($event)" :placeholder="$t('CHOOSE')"
            slot="a">
            <Option v-for="(item) in cclSuppliers" :value="item.vendorName" :key="item.vendorName">
              {{ item.vendorName }}
            </Option>
          </Select>
          <Select class="Select" style="border-color:red;border-width:1px;border-style:solid;" v-model="mainCoreUlNumber"
            @on-change="changemMainCoreUlNumber($event)" :placeholder="$t('CHOOSE')" slot="b">
            <Option v-for="(item) in coreUlNumbers" :value="item.partNoDesc" :key="item.partNoDesc">
              {{ item.partNoDesc }}
            </Option>
          </Select>
          <Input class="Input" style="border-color:red;border-width:1px;border-style:solid;"
            v-model="pwbQuotation.mainCoreUP" slot="c" :disabled="canModifyMainCoreUp" />
          <Input class="Input" v-model="pwbQuotation.mainSourceCclShare" :maxlength="3" slot="d" />
        </FormRowTwo>
        <FormRowTwo
          :fieldNameArr="[$t('SECOND_CCL_SUPPLIER') + ': ', $t('SECOND_CCL_UL_NUMBER') + ': ', $t('SECOND_CORE_UP') + ': ', $t('SECOND_SOURCE_CCL_SHARE') + ': ']"
          :fieldWidthArr="[414, 414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152, 152]">
          <Select class="Select" v-model="secondSourceCclSupplier" @on-change="changeSecondCclSupplier($event)"
            :placeholder="$t('CHOOSE')" slot="a">
            <Option v-for="(item) in secoudCclSuppliers" :value="item.vendorName" :key="item.vendorName">
              {{ item.vendorName }}
            </Option>
          </Select>
          <Select class="Select" v-model="secondCoreUlNumber" @on-change="changemSecondCoreUlNumber($event)"
            :placeholder="$t('CHOOSE')" slot="b">
            <Option v-for="(item) in secondCoreUlNumbers" :value="item.partNoDesc" :key="item.partNoDesc">
              {{ item.partNoDesc }}
            </Option>
          </Select>
          <Input class="Input" v-model="pwbQuotation.secondCoreUP" slot="c" :disabled="canModifySecondCoreUp" />
          <Input class="Input" v-model="secondSourceCclShare" slot="d" :disabled="true" />
        </FormRowTwo>
      </Card>
    </Feature>

    <Feature v-if="showStepThree" :title="$t('QUOTATION')" :iconClass="'fa-pencil-square-o'">
      <Tabs>
        <TabPane :label="'A.' + this.$t('MATERIAL_COST')">
          <FormRowTwo :fieldNameArr="[$t('PCB_PRICE_SHEET_OR_ACTUAL_PANEL_BASE') + ': ']">
            <Input class="Input" v-model="pwbQuotation.pcbPrice" @on-change="resetPriceCalculate()" slot="a"
              :disabled="canModifyPcbPrice" style="border-color:red;border-width:1px;border-style:solid;" />
          </FormRowTwo>
          <FormRowTwo
            :fieldNameArr="[$t('PANEL_LENGTH') + '(mm)' + ': ', $t('PANEL_WIDTH') + '(mm)' + ': ', $t('PN_LENGTH') + '(mm)' + ': ', $t('PN_WIDTH') + '(mm)' + ': ', $t('PN_IN_PANEL') + ': ']"
            :fieldWidthArr="[364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102]">
            <Input class="Input" v-model="pwbQuotation.panelLength" @on-change="resetPriceCalculate()" slot="a"
              :disabled="!quotation.editable" style="border-color:red;border-width:1px;border-style:solid;" />
            <Input class="Input" v-model="pwbQuotation.panelWidth" @on-change="resetPriceCalculate()" slot="b"
              :disabled="!quotation.editable" style="border-color:red;border-width:1px;border-style:solid;" />
            <Input class="Input" v-model="pwbQuotation.pnLength" @on-change="resetPriceCalculate()" slot="c"
              :disabled="!quotation.editable" style="border-color:red;border-width:1px;border-style:solid;" />
            <Input class="Input" v-model="pwbQuotation.pnWidth" @on-change="resetPriceCalculate()" slot="d"
              :disabled="!quotation.editable" style="border-color:red;border-width:1px;border-style:solid;" />
            <Input class="Input" v-model="pwbQuotation.pnInPanel" @on-change="resetPriceCalculate()" slot="e"
              :disabled="!quotation.editable" style="border-color:red;border-width:1px;border-style:solid;" />
            <Button type="primary" @click="calculate" slot="f">{{ $t('CALCULATE') }}</Button>
          </FormRowTwo>
          <Card v-if="showStepFour" :title="$t('SHEET_DATA')" class="card-info">
            <FormRowTwo
              :fieldNameArr="[$t('DELTA_SHEET_SIZE') + '(inch)' + ': ', $t('SUPPLIER_SHEET_SIZE') + '(inch)' + ': ', $t('PANEL_SHEET') + ': ', $t('PN_IN_SHEET') + '(Pcs/Sheet)' + ': ']"
              :fieldWidthArr="[414, 414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152, 152]">
              <Input class="Input" v-model="pwbQuotation.deltaSheetSize" slot="a" :disabled="true" />
              <Select class="Select" v-model="pwbQuotation.supplierSheetSize" slot="b"
                style="border-color:red;border-width:1px;border-style:solid;">
                <Option v-for="item in pnInPanels" :value="item" :key="item">{{ item }}</Option>
              </Select>
              <Input class="Input" v-model="pwbQuotation.panelSheet" slot="c" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.pnInSheet" slot="d" :disabled="true" />
            </FormRowTwo>
            <FormRowTwo
              :fieldNameArr="[$t('PANEL_AREA') + '(m*m)' + ': ', $t('PN_AREA') + '(m*m)' + ': ', $t('PN_UTILIZATION') + '(%)' + ': ', $t('PANEL_UTILIZATION') + '(%)' + ': ']"
              :fieldWidthArr="[414, 414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152, 152]">
              <Input class="Input" v-model="pwbQuotation.area" slot="a" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.pnArea" slot="b" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.pnUtilization" slot="c" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.panelUtilization" slot="d" :disabled="true" />
            </FormRowTwo>
            <FormRowTwo
              :fieldNameArr="[$t('AB_COMBINE_RATIO') + '(%)' + ': ', $t('NUMBER_OF_DRILL_QTY') + ': ', $t('SLOT_LENGTH') + '(m)' + ': ', $t('GOLD_AREA') + '(mm*mm)' + ': ']"
              :fieldWidthArr="[414, 414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152, 152]">
              <Input class="Input" v-model="pwbQuotation.combineRatio" slot="a"
                style="border-color:red;border-width:1px;border-style:solid;" />
              <Input class="Input" v-model="pwbQuotation.numberOfDrill" slot="b" />
              <Input class="Input" v-model="pwbQuotation.slotLength" slot="c" />
              <Input class="Input" v-model="pwbQuotation.goldArea" slot="d" />
            </FormRowTwo>
            <FormRowTwo
              :fieldNameArr="[$t('PN_CODE_CCL_AREA') + '(m2))' + ': ', $t('NUMBER_OF_INNER_CORE_CCL_SHEETS') + ': ']"
              :fieldWidthArr="[484, 484]" :fieldSpanWidthArr="[222, 222]">
              <Input class="Input" v-model="pwbQuotation.pnCoreDivisionArea" slot="a" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.innerCoreDivisionCclSheets" slot="b"
                style="border-color:red;border-width:1px;border-style:solid;" />
            </FormRowTwo>
          </Card>
        </TabPane>
        <TabPane :label="'B.' + this.$t('SURFACE_FINISH_COST')" v-if="showStepFour">
          <FormRowTwo :fieldNameArr="[$t('SURFACE_COST_ITEM') + ': ', $t('UNIT_PRICE') + ': ']">
            <Select class="Select" style="z-index:9999;" @on-change="changeSurfaceCostItem($event)" slot="a">
              <Option v-for="item in surfaceCostItemArray" :value="item.itemId" :key="item.itemId">{{ item.costItemName }}
              </Option>
            </Select>
            <Input class="Input" v-model="costItemPrice" slot="b" />
            <Button type="primary" @click="addSurfceCostItem" slot="c">{{ $t('ADD') }}</Button>
          </FormRowTwo>
          <FormRowTwo :fieldNameArr="['']">
            <Table width="900" border :columns="surfaceCostItemSchema" :data="surfaceCostItems" slot="a">
              <template slot-scope="{ row }" slot="action">
                <Button type="error" shape="circle" icon="md-trash" @click="deleteSurfaceCostItem(row)"></Button>
              </template>
            </Table>
          </FormRowTwo>
        </TabPane>
        <TabPane :label="'C.' + this.$t('PROCESS_COST')" v-if="showStepFour">
          <FormRowTwo :fieldNameArr="[$t('PROCESS_COST_ITEM') + ': ', $t('UNIT_PRICE') + ': ']">
            <Select class="Select" style="z-index:9999;" @on-change="changeProcessCostItem($event)" slot="a">
              <Option v-for="item in processCostItemArray" :value="item.itemId" :key="item.itemId">{{ item.costItemName }}
              </Option>
            </Select>
            <Input class="Input" v-model="costItemPrice" slot="b" />
            <Button type="primary" @click="addProcessCostItem" slot="c">{{ $t('ADD') }}</Button>
          </FormRowTwo>
          <FormRowTwo :fieldNameArr="['']">
            <Table width="900" border :columns="processCostItemSchema" :data="processCostItems" slot="a">
              <template slot-scope="{ row }" slot="action">
                <Button type="error" shape="circle" icon="md-trash" @click="deleteProcessCostItem(row)"></Button>
              </template>
            </Table>
          </FormRowTwo>
        </TabPane>
      </Tabs>
    </Feature>

    <FormRow v-if="showStepFour" :fieldNameArr="[$t('')]">
      <Table width="600" border :columns="priceColumnList" :data="priceList" slot="a">
      </Table>
    </FormRow>

    <div v-if="showStepEight">
      <FormRowTwo :fieldNameArr="['*' + $t('YOUR_PRICE'), '/1 ' + quotation.unit]" :fieldWidthArr="[362]"
        :fieldSpanWidthArr="[100]">
        <Input v-model="pwbQuotation.deltaPnPrice" :disabled="true" ref="yourPrice" slot="a"
          style="border-color:red;border-width:1px;border-style:solid;" />
      </FormRowTwo>
      <FormRowTwo v-if="quotation.editable"
        :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]"
        :fieldWidthArr="[554, 554]" :fieldSpanWidthArr="[292, 292]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload" style="border-color:red;border-width:1px;border-style:solid;">{{ $t('UPLOAD')
          }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD') }}</Button>
      </FormRowTwo>
      <FormRowTwo v-if="supplierAttachmentExited" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="showSupplierQuotationFiles" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
            <Button v-if="quotation.editable" type="error" shape="circle" icon="md-close-circle"
              @click="deleteDocument(row)"></Button>
          </template>
        </Table>
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('SUPPLIER_REMARK') + ': ']">
        <Input style="width: 800px" :maxlength="500" type="textarea" :rows="3" v-model="pwbQuotation.supplierRemark"
          slot="a"></Input>
      </FormRowTwo>
    </div>

    <ButtonRow>
      <Button v-if="quotation.editable" type="primary" @click="Save" slot="0">{{ $t('SAVE') }}</Button>
      <Button v-if="quotation.editable" type="primary" @click="Submit" slot="1">{{ $t('SUBMIT') }}</Button>
      <Button v-if="isMutiple && quotation.editable" type="primary" @click="Upload" slot="2">{{ $t('UPLOAD') }}</Button>
      <Button type="primary" @click="Back" slot="3">{{ $t('BACK') }}</Button>
    </ButtonRow>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="commentsModal"
      :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="comments"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true" v-model="errorMsgModal"
      :title="$t('QUOTATION')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="errorMsgColumnList" :data="errorMessages" max-height="800"></Table>
      </div>
    </Modal>
  </section>
</template>
  
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { DateToString, CheckFloat, CheckNumber } from "@/util/common"
import { FileSchemaList } from "@/util/tableTitle"
import PLMDocument from '../../components/PLMDocument.vue'
import { DownloadFile, FloraEditorConfig, Translate } from "@/util/common"
import FormRowTwo from '@/components/FormRowTwo'
var _ = require('lodash');

export default {
  name: "SupplierPwbMatintain",
  components: {
    PLMDocument,
    FormRowTwo
  },
  data() {
    return {
      FloraEditorConfigRemark: FloraEditorConfig(100),
      FloraEditorConfig: FloraEditorConfig(""),
      comments: '',
      uuid: '',
      formNo: '',
      quotation: {},
      file: null,
      batchAttachmentFile: null,
      batchFile: null,
      supplierQuotationFiles: [],
      showSupplierQuotationFiles: [],
      plmQuotationDocuments: [],
      cpcToVendorAttachments: [],
      loadingStatus: false,
      commentsModal: false,
      uploadModel: false,
      errorMsgModal: false,
      errorMessages: [],
      cclLaminateTypes: [],
      layers: [],
      pcbThicknesses: [],
      tgs: [],
      externalCopperThicknesses: [],
      internalCopperThicknesses: [],
      internalCoreThicknesses: [],
      cclSuppliers: [],
      mainSourceCclSupplier: '',
      secondSourceCclSupplier: '',
      coreUlNumbers: [],
      mainCoreUlNumber: '',
      secondCoreUlNumber: '',
      canModifyMainCoreUp: true,
      canModifySecondCoreUp: true,
      canModifyPcbPrice: true,
      pcbMaster: {},
      costItemPrice: '',
      surfaceCostItem: {},
      surfaceCostItems: [],
      surfaceCostItemArray: [],
      processCostItem: {},
      processCostItems: [],
      processCostItemArray: [],
      priceList: [{
        key: 'MATERIAL_COST',
        value: ''
      }, {
        key: 'SURFACE_FINISH_COST',
        value: ''
      }, {
        key: 'PROCESSING_COST',
        value: ''
      }, {
        key: 'DELTA_PN_UP_PRICE_USD',
        value: ''
      }, {
        key: 'DELTA_PN_UP_PRICE',
        value: ''
      }, {
        key: 'SPECIAL_COST_DOWN',
        value: ''
      }
      ],
      priceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ITEM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            let html = "<lable>" + this.$t(params.row.key) + "</lable>"
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          align: 'center',
          width: 200,
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            let styleInfo = {
              'border-width': '1px',
              'border-style': 'solid'
            }
            if (this.priceList[params.index].key == "SPECIAL_COST_DOWN") {
              styleInfo['border-color'] = 'red'
            }

            if (this.priceList[params.index].key != "SPECIAL_COST_DOWN") {
              return h("div", {
                domProps: {
                  innerHTML: "<lable>" + this.priceList[params.index].value + "</lable>"
                }
              });
            } else {
              return h('Input', {
                props: {
                  type: 'text',
                  value: this.priceList[params.index].value
                },
                style: styleInfo,
                on: {
                  'on-change': (event) => {
                    if (event.target.value == '' || CheckFloat(event.target.value)) {
                      this.pwbQuotation.specialCostDown = event.target.value
                      this.priceList.forEach(price => {
                        if (price.key == "DELTA_PN_UP_PRICE_USD") {
                          this.pwbQuotation.deltaPnPriceUsd = ((Number(this.pwbQuotation.materialCost) + Number(this.pwbQuotation.surfaceFinishCost) + Number(this.pwbQuotation.processCost)) * (1 - Number(event.target.value) / 100)).toFixed(4)
                          price.value = this.pwbQuotation.deltaPnPriceUsd
                        } else if (price.key == "DELTA_PN_UP_PRICE") {
                          this.pwbQuotation.deltaPnPrice = ((Number(this.pwbQuotation.materialCost) + Number(this.pwbQuotation.surfaceFinishCost) + Number(this.pwbQuotation.processCost)) * (1 - Number(event.target.value) / 100) * this.cpcExchangeRate).toFixed(4)
                          price.value = this.pwbQuotation.deltaPnPrice
                        }
                      })
                    } else {
                      AlertInfo(this, this.$t('PRICE_MUST_BE_NUMBER')).then(() => {
                      })
                    }
                  }
                }
              })
            }
          },
          align: 'center',
          width: 200,
        }
      ],
      pwbQuotation: {
        deltaExchangeRate: "",
        cpcExchangeRate: undefined,
        rfqBase: "",
        cclLaminateType: "",
        layer: "",
        pcbThickness: "",
        internalCoreThickness: "",
        tg: "",
        externalCopperThickness: "",
        internalCopperThickness: "",
        mainSourceCclSupplier: {
          vendorCode: ""
        },
        mainSourceCclShare: 100,
        mainCoreUlNumber: {
          partNoDesc: ""
        },
        mainCoreUP: "",
        secondSourceCclSupplier: {
          vendorCode: ""
        },
        secondCoreUlNumber: {
          partNoDesc: ""
        },
        secondCoreUP: "",
        pcbPrice: "",
        panelLength: "",
        panelWidth: "",
        pnLength: "",
        pnWidth: "",
        area: "",
        pnArea: "",
        supplierSheetSize: "",
        deltaSheetSize: "",
        panelSheet: "",
        pnInSheet: "",
        pnInPanel: "",
        pnUtilization: "",
        panelUtilization: "",
        combineRatio: 0,
        numberOfDrill: "",
        slotLength: "",
        goldArea: "",
        materialCost: "",
        surfaceFinishCost: "",
        processCost: "",
        specialCostDown: 0,
        deltaPnPriceUsd: "",
        deltaPnPrice: "",
        supplierRemark: ""
      },
      surfaceCostItemSchema: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('SURFACE_COST_ITEM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'costItemName',
          align: 'center',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'unitPrice',
          align: 'center',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE_FOR_PCS_SHEET')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'unitPriceForPcsSheet',
          align: 'center',
        },
        {
          title: this.$t("ACTION"),
          slot: "action",
          width: 120,
          align: "center",
        },
      ],
      processCostItemSchema: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('PROCESS_COST_ITEM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'costItemName',
          align: 'center',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'unitPrice',
          align: 'center',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE_FOR_PCS_SHEET')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'unitPriceForPcsSheet',
          align: 'center',
        },
        {
          title: this.$t("ACTION"),
          slot: "action",
          width: 120,
          align: "center",
        },
      ],
      documentColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('FILE_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'fileName',
          align: 'center',
          width: 200,
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLM_FILES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 120,
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-download",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.downloadDocument(params.row)
                },
              },
            })
          }
        },
      ],
      scalePriceList: [],
      scalePriceColumnList: [
        {
          title: 'Item',
          key: 'item',
          align: 'center',
          width: 80
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE'); + '<br>' + this.$t('QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                type: 'text',
                value: this.scalePriceList[params.index].scaleQuantity
              },
              on: {
                'on-change': (event) => {
                  this.scalePriceList[params.index].scaleQuantity = event.target.value
                }
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                type: 'text',
                value: this.scalePriceList[params.index].scalePrice
              },
              on: {
                'on-change': (event) => {
                  this.scalePriceList[params.index].scalePrice = event.target.value
                }
              }
            })
          }
        }
      ],
      fileSchemaList: FileSchemaList(this),
      errorMsgColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('FORM_NO');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Form No",
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('YOUR_PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Your Price",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ERROR_MESSAGE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "errorMessage",
          render: (h, params) => {
            let html = "<lable>" + params.row.errorMessage + "</lable>";
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          width: 400,
          align: "center",
        },
      ],
    }
  },
  created() {
    const vueInstance = this
    vueInstance.toggleLoading(true)
    if (vueInstance.getSupplierQuotationId()) {
      vueInstance.uuid = vueInstance.getSupplierQuotationId()
      vueInstance.formNo = vueInstance.getSupplierFormNo()
      vueInstance.$searchSupplierPwb(vueInstance).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    } else if (vueInstance.getQuotationList().length > 0) {
      vueInstance.formNo = vueInstance.getQuotationList()[0].formNo
      vueInstance.uuid = vueInstance.getQuotationList()[0].uuid
      vueInstance.$searchSupplierPwb(vueInstance).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    } else {
      vueInstance.toggleLoading(false)
      vueInstance.Back()
    }

    vueInstance.$getReferenceData(vueInstance, "/cclMaster/find/cclLaminateType").then(data => {
      vueInstance.cclLaminateTypes = data
    }).catch((error) => {
      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      })
    })
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getQuotationList", "getSupplierQuotationId", "getModalSize", "getSupplierFormNo", "getGroupCode"]),
    ...mapActions(["toggleLoading"]),
    changeRfqBase() {
      this.$searchPcbMaster(this)
    },
    chagneCclLaminateType(value) {
      const vueInstance = this
      vueInstance.pwbQuotation.deltaPnPrice = ""
      vueInstance.pwbQuotation.layer = ""
      vueInstance.pwbQuotation.pcbThickness = ""
      vueInstance.pwbQuotation.tg = ""
      vueInstance.pwbQuotation.externalCopperThickness = ""
      vueInstance.pwbQuotation.internalCopperThickness = ""
      vueInstance.pwbQuotation.internalCoreThickness = ""
      vueInstance.mainSourceCclSupplier = ""
      vueInstance.secondSourceCclSupplier = ""
      vueInstance.mainCoreUlNumber = ""
      vueInstance.secondCoreUlNumber = ""
      vueInstance.pwbQuotation.mainSourceCclSupplier = {
        vendorCode: ""
      }
      vueInstance.pwbQuotation.secondSourceCclSupplier = {
        vendorCode: ""
      }
      vueInstance.pwbQuotation.mainCoreUlNumber = {
        partNoDesc: ""
      }
      vueInstance.pwbQuotation.secondCoreUlNumber = {
        partNoDesc: ""
      }
      vueInstance.pwbQuotation.materialCost = ""
      vueInstance.pwbQuotation.surfaceFinishCost = ""
      vueInstance.pwbQuotation.processCost = ""
      vueInstance.pwbQuotation.deltaPnPriceUsd = ""
      vueInstance.pwbQuotation.deltaPnPrice = ""
      vueInstance.pwbQuotation.specialCostDown = 0
      vueInstance.priceList.forEach(element => {
        element.value = ""
      })
      vueInstance.pwbQuotation.supplierSheetSize = ""
      vueInstance.pwbQuotation.deltaSheetSize = ""
      vueInstance.pwbQuotation.pnInSheet = ""
      vueInstance.pwbQuotation.pnInPanel = ""
      vueInstance.pwbQuotation.pnUtilization = ""
      vueInstance.pwbQuotation.panelUtilization = ""
      vueInstance.pwbQuotation.combineRatio = ""
      vueInstance.pwbQuotation.numberOfDrill = ""
      vueInstance.pwbQuotation.slotLength = ""
      vueInstance.pwbQuotation.goldArea = ""

      vueInstance.toggleLoading(true)
      vueInstance.$getReferenceData(vueInstance, "pcbMaster/find/paramter/" + value).then(data => {
        vueInstance.toggleLoading(false)
        data.forEach(temp => {
          if (temp.key == "Layer") {
            vueInstance.layers = temp.datas
          }
          if (temp.key == "PcbThickness") {
            vueInstance.pcbThicknesses = temp.datas
          }
        })
      }).catch((error) => {
        vueInstance.toggleLoading(false)
        AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
        })
      })

      vueInstance.$getReferenceData(vueInstance, "cclMaster/find/paramter/" + value).then(data => {
        data.forEach(temp => {
          if (temp.key == "Tg") {
            vueInstance.tgs = temp.datas
          }
          if (temp.key == "ExternalCopperThickness") {
            vueInstance.externalCopperThicknesses = temp.datas
          }
          if (temp.key == "InternalCopperThickness") {
            vueInstance.internalCopperThicknesses = temp.datas
          }
          if (temp.key == "InternalCoreThickness") {
            vueInstance.internalCoreThicknesses = temp.datas
          }
          if (temp.key == "CclSupplier") {
            vueInstance.cclSuppliers = temp.datas
          }
          if (temp.key == "CoreUlNumber") {
            vueInstance.coreUlNumbers = temp.datas
          }
        })
      }).catch((error) => {
        AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
        })
      })
    },
    searchPcbLayer() {
      if (!this.pwbQuotation.layer || Number(this.pwbQuotation.layer) === 0) {
      } else {
        if (Number(this.pwbQuotation.layer) === 2 || Number(this.pwbQuotation.layer) === 4) {
          this.pwbQuotation.innerCoreDivisionCclSheets = 1
        } else if (Number(this.pwbQuotation.layer) >= 6) {
          this.pwbQuotation.innerCoreDivisionCclSheets = (this.pwbQuotation.layer - 2) / 2
        }
      }
      let vueInstance = this
      vueInstance.$searchPcbMaster(vueInstance)
      vueInstance.$searchMainCoreUpPrice(vueInstance).then(data => {
        if (data) {
          vueInstance.pwbQuotation.mainCoreUP = data
          vueInstance.canModifyMainCoreUp = true
        } else {
          vueInstance.pwbQuotation.mainCoreUP = ""
          vueInstance.canModifyMainCoreUp = false
        }
      })
      vueInstance.$searchSecondCoreUpPrice(vueInstance).then(data => {
        if (data) {
          vueInstance.pwbQuotation.secondCoreUP = data
          vueInstance.canModifySecondCoreUp = true
        } else {
          vueInstance.pwbQuotation.secondCoreUP = ""
          vueInstance.canModifySecondCoreUp = false
        }
      })
    },
    updatePcbMaster() {
      let vueInstance = this
      vueInstance.$searchPcbMaster(vueInstance)
      vueInstance.$searchMainCoreUpPrice(vueInstance).then(data => {
        if (data) {
          vueInstance.pwbQuotation.mainCoreUP = data
          vueInstance.canModifyMainCoreUp = true
        } else {
          vueInstance.pwbQuotation.mainCoreUP = ""
          vueInstance.canModifyMainCoreUp = false
        }
      })
      vueInstance.$searchSecondCoreUpPrice(vueInstance).then(data => {
        if (data) {
          vueInstance.pwbQuotation.secondCoreUP = data
          vueInstance.canModifySecondCoreUp = true
        } else {
          vueInstance.pwbQuotation.secondCoreUP = ""
          vueInstance.canModifySecondCoreUp = false
        }
      })
    },
    changeMainCclSupplier(value) {
      if (value) {
        const vueInstance = this
        vueInstance.pwbQuotation.mainSourceCclSupplier = vueInstance.cclSuppliers.find(function (cclSupplier) {
          return cclSupplier.vendorName == value
        });
        vueInstance.mainCoreUlNumber = ""
        vueInstance.canModifyMainCoreUp = true
        vueInstance.pwbQuotation.mainCoreUP = ""
        vueInstance.pwbQuotation.mainCoreUlNumber = {
          partNoDesc: ""
        }
        vueInstance.pwbQuotation.secondSourceCclSupplier = {
          vendorCode: ""
        }
      }
    },
    changemMainCoreUlNumber(value) {
      const vueInstance = this
      if (value) {
        vueInstance.pwbQuotation.mainCoreUlNumber = vueInstance.coreUlNumbers.find(function (coreUlNumber) {
          return coreUlNumber.partNoDesc == value
        });
        vueInstance.$searchPcbMaster(vueInstance)
        vueInstance.$searchMainCoreUpPrice(vueInstance).then(data => {
          if (data) {
            vueInstance.pwbQuotation.mainCoreUP = data
            vueInstance.canModifyMainCoreUp = true
          } else {
            vueInstance.pwbQuotation.mainCoreUP = ""
            vueInstance.canModifyMainCoreUp = false
          }
        })
      } else {
        vueInstance.pwbQuotation.mainCoreUP = ""
      }
    },
    changeSecondCclSupplier(value) {
      if (value) {
        const vueInstance = this
        vueInstance.pwbQuotation.secondSourceCclSupplier = vueInstance.cclSuppliers.find(function (cclSupplier) {
          return cclSupplier.vendorName == value
        });
        vueInstance.secondCoreUlNumber = ""
        vueInstance.canModifySecondCoreUp = true
        vueInstance.pwbQuotation.secondCoreUP = ""
        vueInstance.pwbQuotation.secondCoreUlNumber = {
          partNoDesc: ""
        }
      }
    },
    changemSecondCoreUlNumber(value) {
      const vueInstance = this
      if (value) {
        vueInstance.pwbQuotation.secondCoreUlNumber = vueInstance.coreUlNumbers.find(function (coreUlNumber) {
          return coreUlNumber.partNoDesc == value
        });

        vueInstance.$searchSecondCoreUpPrice(vueInstance).then(data => {
          if (data) {
            vueInstance.pwbQuotation.secondCoreUP = data
            vueInstance.canModifySecondCoreUp = true
          } else {
            vueInstance.pwbQuotation.secondCoreUP = ""
            vueInstance.canModifySecondCoreUp = false
          }
        })
      } else {
        vueInstance.pwbQuotation.secondCoreUP = ""
      }
    },
    resetPriceCalculate() {
      this.pwbQuotation.deltaSheetSize = ""
      this.pwbQuotation.supplierSheetSize = ""
      this.pwbQuotation.panelSheet = ""
      this.pwbQuotation.pnInSheet = ""
      this.pwbQuotation.area = ""
      this.pwbQuotation.pnArea = ""
      this.pwbQuotation.pnUtilization = ""
      this.pwbQuotation.panelUtilization = ""
      this.pwbQuotation.combineRatio = 0
      this.pwbQuotation.numberOfDrill = ""
      this.pwbQuotation.slotLength = ""
      this.pwbQuotation.goldArea = ""
      this.pwbQuotation.pnCoreDivisionArea = ""
      this.pwbQuotation.materialCost = ""
      this.pwbQuotation.surfaceFinishCost = ""
      this.pwbQuotation.processCost = ""
      this.pwbQuotation.specialCostDown = 0
      this.pwbQuotation.deltaPnPriceUsd = ""
      this.pwbQuotation.deltaPnPrice = ""
    },
    calculate() {
      let vueInstance = this
      let errorMessage = validationCal(vueInstance, vueInstance.pwbQuotation, "")
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("supplier/pwb/calculate", JSON.stringify({
            "pcbPrice": vueInstance.pwbQuotation.pcbPrice,
            "panelLength": vueInstance.pwbQuotation.panelLength,
            "panelWidth": vueInstance.pwbQuotation.panelWidth,
            "pnLength": vueInstance.pwbQuotation.pnLength,
            "pnWidth": vueInstance.pwbQuotation.pnWidth,
            "pnInPanel": vueInstance.pwbQuotation.pnInPanel,
            "pcbMasterDto": {
              "processLose": vueInstance.pcbMaster.processLose ? vueInstance.pcbMaster.processLose : 10,
              "extend": vueInstance.pcbMaster.extend ? vueInstance.pcbMaster.extend : 0
            }
          }))
          .then((response) => {
            vueInstance.toggleLoading(false)
            vueInstance.pwbQuotation.deltaSheetSize = response.data.deltaSheetSize
            vueInstance.pwbQuotation.supplierSheetSize = response.data.supplierSheetSize
            vueInstance.pwbQuotation.area = response.data.area
            vueInstance.pwbQuotation.panelSheet = response.data.panelSheet
            vueInstance.pwbQuotation.panelUtilization = response.data.panelUtilization
            vueInstance.pwbQuotation.pnUtilization = response.data.pnUtilization
            vueInstance.pwbQuotation.pnArea = response.data.pnArea
            vueInstance.pwbQuotation.pnInSheet = response.data.pnInSheet
            vueInstance.pwbQuotation.pnCoreDivisionArea = response.data.pnCoreDivisionArea

            if (vueInstance.processCostItems) {
              vueInstance.processCostItems.forEach(item => {
                if (item.costItemName == "Golden finger(金手指)") {
                  item.unitPriceForPcsSheet = item.unitPrice
                } else {
                  item.unitPriceForPcsSheet = (Number(item.unitPrice) / Number(vueInstance.pwbQuotation.pnInSheet)).toFixed(4)
                }
              })
            }

            vueInstance.$buildPcbPriceList(vueInstance, false)
          })
          .catch(() => {
            this.toggleLoading(false)
          })
      }
    },
    changeSurfaceCostItem(event) {
      this.surfaceCostItem = this.surfaceCostItemArray.find(function (item, index, array) {
        return item.itemId == event
      })
    },
    addSurfceCostItem() {
      let vueInstance = this
      let errorMessage = vueInstance.validCostItem(vueInstance.surfaceCostItems, vueInstance.surfaceCostItem)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        if (!_.isEmpty(vueInstance.surfaceCostItem) && this.costItemPrice != "") {
          let temp = {
            type: "",
            itemId: "",
            costItemName: "",
            unitPrice: 0,
            unitPriceForPcsSheet: 0
          }
          temp.type = vueInstance.surfaceCostItem.type
          temp.itemId = vueInstance.surfaceCostItem.itemId
          temp.costItemName = vueInstance.surfaceCostItem.costItemName
          temp.unitPrice = Number(vueInstance.costItemPrice)
          temp.unitPriceForPcsSheet = (Number(temp.unitPrice) / Number(vueInstance.pwbQuotation.pnInSheet)).toFixed(4)
          vueInstance.surfaceCostItems.push(temp)
          vueInstance.costItemPrice = ""
          vueInstance.surfaceCostItem = {}
          vueInstance.$buildPcbPriceList(vueInstance, true)
        }
      }
    },
    deleteSurfaceCostItem(row) {
      let vueInstance = this
      vueInstance.surfaceCostItems.splice(row._index, 1)
      vueInstance.$buildPcbPriceList(vueInstance, true)
    },
    changeProcessCostItem(event) {
      let vueInstance = this
      vueInstance.processCostItem = vueInstance.processCostItemArray.find(function (item, index, array) {
        return item.itemId == event
      })
    },
    addProcessCostItem() {
      let vueInstance = this
      let errorMessage = vueInstance.validCostItem(vueInstance.processCostItems, vueInstance.processCostItem)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        if (!_.isEmpty(vueInstance.processCostItem) && vueInstance.costItemPrice != "") {
          let temp = {
            type: "",
            itemId: "",
            costItemName: "",
            unitPrice: 0,
            unitPriceForPcsSheet: 0
          }
          temp.type = vueInstance.processCostItem.type
          temp.itemId = vueInstance.processCostItem.itemId
          temp.costItemName = vueInstance.processCostItem.costItemName
          temp.unitPrice = Number(vueInstance.costItemPrice)
          if (temp.itemId == "01") {
            temp.unitPriceForPcsSheet = temp.unitPrice
          } else {
            temp.unitPriceForPcsSheet = (temp.unitPrice / vueInstance.pwbQuotation.pnInSheet).toFixed(4)
          }
          vueInstance.processCostItems.push(temp)
          vueInstance.costItemPrice = ""
          vueInstance.processCostItem = {}
          vueInstance.$buildPcbPriceList(vueInstance, true)
        }
      }
    },
    deleteProcessCostItem(row) {
      let vueInstance = this
      vueInstance.processCostItems.splice(row._index, 1)
      vueInstance.$buildPcbPriceList(vueInstance, true)
    },
    validCostItem(costItems, costItemObj) {
      let errorMessage = ""
      if (!this.pwbQuotation.pnInSheet) {
        errorMessage = errorMessage + "Please Calculate Panel/Sheet <br>"
      }
      if (!costItemObj) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('UNIT_PRICE') + " <br>"
      }
      let temp = {}
      if (costItems.length > 0 && !_.isEmpty(costItemObj)) {
        temp = costItems.find(function (item, index, array) {
          return item.itemId == costItemObj.itemId
        })
      }
      if (!_.isEmpty(temp)) {
        errorMessage = errorMessage + "Could not add same cost item<br>"
      }
      return errorMessage
    },
    Upload() {
      this.uploadModel = true
    },
    downloadSample() {
      let formNos = []
      this.quotationList.forEach(q => {
        formNos.push(q.formNo)
      })
      this.toggleLoading(true)
      this.$quotationHttp
        .post("supplier/batch-download", JSON.stringify(formNos), { responseType: 'blob' })
        .then((response) => {
          this.toggleLoading(false)
          DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
        })
        .catch(() => {
          this.toggleLoading(false)
        })
    },
    changeFormNo(formNo) {
      let temp = this.getQuotationList().find(quotation => quotation.formNo == formNo)
      this.formNo = temp.formNo
      this.uuid = temp.uuid
      this.$searchSupplierOthers(this)
    },
    openComments() {
      this.commentsModal = true
    },
    downloadAttachment(row) {
      this.$downloadAttachment(this, row.uuid)
    },
    deleteDocument(row) {
      this.supplierQuotationFiles.forEach(attachment => {
        if (attachment.id == row.id) {
          attachment.deleted = true
        }
      })
      this.showSupplierQuotationFiles = this.supplierQuotationFiles.filter(attachment => !attachment.deleted)
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      if (this.showSupplierQuotationFiles.length < 1) {
        let fd = new FormData()
        fd.append('file', this.file)
        fd.append('description', "quotaion attachement")
        this.toggleLoading(true)
        this.$fileHttp
          .post("/attachment/upload-single?description=quotation" + this.quotation.uuid, fd)
          .then((response) => {
            this.supplierQuotationFiles.push(response.data)
            this.showSupplierQuotationFiles.push(response.data)
            this.file = null
            this.toggleLoading(false)
          })
          .catch(() => {
            this.toggleLoading(false)
          })
      } else {
        let text = "Could not upload more than one quotation file."
        this.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    },
    Save() {
      const vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.quotation.formNo, vueInstance.pwbQuotation.deltaPnPrice, vueInstance.quotation.currency, vueInstance.pwbQuotation)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/update", JSON.stringify(buildCriteria(vueInstance)))
          .then((response) => {
          })
          .catch((error) => {
            if (error.response.status == 444) {
              let text = vueInstance.$buildErrorMessage(error)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                text,
              })
            }
          })
          .finally(() => {
            vueInstance.toggleLoading(false)
          })
      }
    },
    Submit() {
      const vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.quotation.formNo, vueInstance.pwbQuotation.deltaPnPrice, vueInstance.quotation.currency, vueInstance.pwbQuotation)
        + vueInstance.$validSupplierAttachments(vueInstance, vueInstance.showSupplierQuotationFiles.length)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        let data = buildCriteria(vueInstance)
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/submit", JSON.stringify(data))
          .then((response) => {
            if (vueInstance.getSupplierQuotationId()) {
              vueInstance.toggleLoading(false)
              vueInstance.Back()
            } else if (vueInstance.getQuotationList().length > 0) {
              vueInstance.$searchSupplierPwb(vueInstance).then(vueInstance => {
                vueInstance.toggleLoading(false)
              })
            } else {
              vueInstance.toggleLoading(false)
              vueInstance.Back()
            }
          })
          .catch(() => {
            vueInstance.toggleLoading(false)
          })
      }
    },
    Back() {
      this.$router.push({ name: 'SUPPLIER_MAINTAIN' })
    },
    valid(formNo, price, currency, pwbQuotation) {
      let errorMessage = this.$validSupplierQuotationPrice(this, "FormNo(" + formNo + ") -", price, currency)

      if (!pwbQuotation.rfqBase) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + "RFQ Base <br>"
      }
      if (!pwbQuotation.cclLaminateType) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('CCL_LAMINATE_TYPE') + " <br>"
      }
      if (!pwbQuotation.layer && Number(pwbQuotation.layer) !== 0) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('LAYER') + " <br>"
      }
      if (!pwbQuotation.pcbThickness && Number(pwbQuotation.pcbThickness) !== 0) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('PCB_THICKNESS') + " <br>"
      }
      if (!pwbQuotation.externalCopperThickness && Number(pwbQuotation.externalCopperThickness) !== 0) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('EXTERNAL_COPPER_THICKNESS_TITLE') + " <br>"
      }
      if (!pwbQuotation.internalCopperThickness && Number(pwbQuotation.internalCopperThickness) !== 0) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('INTERNAL_COPPER_THICKNESS_TITLE') + " <br>"
      }
      if (!pwbQuotation.mainSourceCclShare) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('MAIN_CCL_SUPPLIER') + " <br>"
      }
      if (!pwbQuotation.mainCoreUlNumber) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('MAIN_CCL_UL_NUMBER') + " <br>"
      }
      if (!pwbQuotation.mainCoreUP && Number(pwbQuotation.mainCoreUP) !== 0) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('MAIN_CORE_UP') + " <br>"
      } else {
        if (!CheckFloat(pwbQuotation.mainCoreUP)) {
          errorMessage = errorMessage + this.$t('MAIN_CORE_UP') + this.$t('MUST_BE_NUMBER') + " <br>"
        } else {
          if (Number(pwbQuotation.mainCoreUP) <= 0) {
            errorMessage = errorMessage + this.$t('MAIN_CORE_UP') + this.$t('MUST_MORE_THAN_ZERO') + " <br>"
          }
        }
      }
      if (!pwbQuotation.mainSourceCclShare) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('MAIN_SOURCE_CCL_SHARE') + " <br>"
      } else {
        if (!CheckNumber(pwbQuotation.mainSourceCclShare)) {
          errorMessage = errorMessage + this.$t('MAIN_SOURCE_CCL_SHARE') + this.$t('MUST_BE_INTEGER') + " <br>"
        }
      }
      if (!pwbQuotation.pcbPrice) {
        errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN') + this.$t('PCB_PRICE_SHEET_OR_ACTUAL_PANEL_BASE') + " <br>"
      } else {
        if (!CheckFloat(pwbQuotation.pcbPrice)) {
          errorMessage = errorMessage + this.$t('PCB_PRICE_SHEET_OR_ACTUAL_PANEL_BASE') + this.$t('PRICE_MUST_BE_NUMBER') + " <br>"
        } else {
          if (Number(pwbQuotation.pcbPrice) <= 0) {
            errorMessage = errorMessage + this.$t('PCB_PRICE_SHEET_OR_ACTUAL_PANEL_BASE') + this.$t('PRICE_MUST_MORE_THAN_ZERO') + " <br>"
          }
        }
      }
      errorMessage = validationCal(this, pwbQuotation, errorMessage)
      if (!pwbQuotation.supplierSheetSize) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('SUPPLIER_SHEET_SIZE') + " <br>"
      }
      if (!pwbQuotation.combineRatio && Number(pwbQuotation.combineRatio) !== 0) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('AB_COMBINE_RATIO') + " <br>"
      } else {
        if (!CheckFloat(pwbQuotation.combineRatio)) {
          errorMessage = errorMessage + this.$t('AB_COMBINE_RATIO') + this.$t('MUST_BE_NUMBER') + " <br>"
        } else {
          if (Number(pwbQuotation.combineRatio) < 0) {
            errorMessage = errorMessage + this.$t('AB_COMBINE_RATIO') + this.$t('CAN_NOT_NEGATIVE') + " <br>"
          }
        }
      }
      if (!pwbQuotation.innerCoreDivisionCclSheets && Number(pwbQuotation.innerCoreDivisionCclSheets) !== 0) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('NUMBER_OF_INNER_CORE_CCL_SHEETS') + " <br>"
      } else {
        if (!CheckNumber(pwbQuotation.innerCoreDivisionCclSheets) && Number(pwbQuotation.innerCoreDivisionCclSheets) !== 0) {
          errorMessage = errorMessage + this.$t('NUMBER_OF_INNER_CORE_CCL_SHEETS') + this.$t('MUST_BE_INTEGER') + " <br>"
        } else {
          if (Number(pwbQuotation.innerCoreDivisionCclSheets) < 0) {
            errorMessage = errorMessage + this.$t('NUMBER_OF_INNER_CORE_CCL_SHEETS') + this.$t('CAN_NOT_NEGATIVE') + " <br>"
          }
        }
      }
      if (!pwbQuotation.specialCostDown && Number(pwbQuotation.specialCostDown) !== 0) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('SPECIAL_COST_DOWN') + " <br>"
      } else {
        if (!CheckFloat(pwbQuotation.specialCostDown)) {
          errorMessage = errorMessage + this.$t('SPECIAL_COST_DOWN') + this.$t('MUST_BE_NUMBER') + " <br>"
        } else {
          if (Number(pwbQuotation.specialCostDown) < 0) {
            errorMessage = errorMessage + this.$t('SPECIAL_COST_DOWN') + this.$t('CAN_NOT_NEGATIVE') + " <br>"
          }
        }
      }
      if (!pwbQuotation.pnUtilization && Number(pwbQuotation.pnUtilization) !== 0) {
        errorMessage = errorMessage + this.$t('PN_UTILIZATION') + this.$t('CAN_NOT_EMPTY') + " <br>"
      } else {
        if (!CheckFloat(pwbQuotation.pnUtilization)) {
          errorMessage = errorMessage + this.$t('PN_UTILIZATION') + this.$t('MUST_BE_NUMBER') + " <br>"
        } else {
          if (Number(pwbQuotation.pnUtilization) > 100) {
            errorMessage = errorMessage + this.$t('PN_UTILIZATION') + this.$t('CAN_NOT_MORE_THAN_100') + "% <br>"
          }
        }
      }
      if (!pwbQuotation.panelUtilization && Number(pwbQuotation.panelUtilization) !== 0) {
        errorMessage = errorMessage + this.$t('PANEL_UTILIZATION') + this.$t('CAN_NOT_EMPTY') + " <br>"
      } else {
        if (!CheckFloat(pwbQuotation.panelUtilization)) {
          errorMessage = errorMessage + this.$t('PANEL_UTILIZATION') + this.$t('MUST_BE_NUMBER') + " <br>"
        } else {
          if (Number(pwbQuotation.panelUtilization) > 100) {
            errorMessage = errorMessage + this.$t('PANEL_UTILIZATION') + this.$t('CAN_NOT_MORE_THAN_100') + "% <br>"
          }
        }
      }

      return errorMessage
    }
  },
  computed: {
    deltaExchangeRate() {
      return (Number(1) / Number(this.quotation.quoteExchangeRate)).toFixed(5)
    },
    cpcExchangeRate: {
      get() {
        return this.pwbQuotation.cpcExchangeRate !== undefined ? this.pwbQuotation.cpcExchangeRate : this.deltaExchangeRate
      },
      set(value) {
        this.pwbQuotation.cpcExchangeRate = value
        vueInstance.$buildPcbPriceList(vueInstance, true)
      }
    },
    actual36() {
      return Number(36) + Number(this.pcbMaster.extend ? this.pcbMaster.extend : 0)
    },
    actual40() {
      return Number(40) + Number(this.pcbMaster.extend ? this.pcbMaster.extend : 0)
    },
    actual42() {
      return Number(42) + Number(this.pcbMaster.extend ? this.pcbMaster.extend : 0)
    },
    actual48() {
      return Number(48) + Number(this.pcbMaster.extend ? this.pcbMaster.extend : 0)
    },
    pnInPanels() {
      return [this.actual36 + "*" + this.actual48, this.actual40 + "*" + this.actual48, this.actual42 + "*" + this.actual48, this.actual48 + "*" + this.actual48]
    },
    quotationList() {
      return this.getQuotationList()
    },
    isMutiple() {
      return this.getQuotationList() && this.getQuotationList().length > 0
    },
    supplierAttachmentExited() {
      return this.showSupplierQuotationFiles && this.showSupplierQuotationFiles.length > 0
    },
    quotationDocumentView() {
      return this.plmQuotationDocuments && this.plmQuotationDocuments.length > 0
    },
    cpcToVendorAttachmentsExited() {
      return this.cpcToVendorAttachments && this.cpcToVendorAttachments.length > 0
    },
    rfqType() {
      if (this.quotation.rfqType) {
        return this.quotation.rfqType.description
      } else {
        ""
      }
    },
    cpcAccountName() {
      return this.quotation.cpcAccount ? this.quotation.cpcAccount.name : ""
    },
    hasComments() {
      return this.comments != ""
    },
    modalSize() {
      return this.getModalSize()
    },
    today() {
      return DateToString(new Date(), "/")
    },
    showStepTwo() {
      return this.pwbQuotation.rfqBase
    },
    showStepThree() {
      return (this.pwbQuotation.layer || this.pwbQuotation.layer === 0) &&
        (this.pwbQuotation.pcbThickness || this.pwbQuotation.pcbThickness === 0) &&
        (this.pwbQuotation.tg) &&
        (this.pwbQuotation.externalCopperThickness || this.pwbQuotation.externalCopperThickness === 0) &&
        (this.pwbQuotation.internalCopperThickness || this.pwbQuotation.internalCopperThickness === 0) &&
        (this.pwbQuotation.internalCoreThickness || this.pwbQuotation.internalCoreThickness === 0)
        && this.mainSourceCclSupplier !== "" && this.mainCoreUlNumber !== ""
    },
    showStepFour() {
      return (this.pwbQuotation.pcbPrice || this.pwbQuotation.pcbPrice === 0)
        && this.pwbQuotation.deltaSheetSize !== ""
    },
    showStepSeven() {
      return this.surfaceCostItems.length > 0 && this.processCostItems.length > 0
    },
    showStepEight() {
      return (this.pwbQuotation.deltaPnPrice || this.pwbQuotation.deltaPnPrice === 0)
        && (this.pwbQuotation.pcbPrice || this.pwbQuotation.pcbPrice === 0)
    },
    secoudCclSuppliers() {
      if (this.pwbQuotation.mainSourceCclSupplier && this.pwbQuotation.mainSourceCclSupplier.uuid) {
        return this.cclSuppliers.filter((cclSupplier) => cclSupplier.uuid != this.pwbQuotation.mainSourceCclSupplier.uuid)
      } else {
        return []
      }
    },
    secondCoreUlNumbers() {
      if (this.pwbQuotation.mainCoreUlNumber && this.pwbQuotation.mainCoreUlNumber.uuid) {
        return this.coreUlNumbers.filter((coreUlNumber) => coreUlNumber.uuid != this.pwbQuotation.mainCoreUlNumber.uuid)
      } else {
        return []
      }
    },
    secondSourceCclShare() {
      return 100 - this.pwbQuotation.mainSourceCclShare
    },
    updateMainSourceCclShare() {
      return this.pwbQuotation.secondSourceCclSupplier && this.pwbQuotation.secondCoreUlNumber
    },
    isCalculate() {
      return (this.pwbQuotation.pcbPrice !== "") &&
        (this.pwbQuotation.panelLength !== "") &&
        (this.pwbQuotation.panelWidth !== "") &&
        (this.pwbQuotation.pnLength !== "") &&
        (this.pwbQuotation.pnWidth !== "") &&
        (this.pwbQuotation.pnInPanel !== "")
    }
  }
}

function validationCal(vueInstance, pwbQuotation, errorMessage) {
  if (!pwbQuotation.panelLength) {
    errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('PANEL_LENGTH') + " <br>"
  } else {
    if (!CheckNumber(pwbQuotation.panelLength)) {
      errorMessage = errorMessage + vueInstance.$t('PANEL_LENGTH') + vueInstance.$t('MUST_BE_INTEGER') + " <br>"
    } else if (Number(1219.2) < Number(pwbQuotation.panelLength)) {
      errorMessage = errorMessage + vueInstance.$t('PANEL_LENGTH') + vueInstance.$t('MUST_SAMLL_THAN_SHEET_SIZE') + " <br>"
    }
  }
  if (!pwbQuotation.panelWidth) {
    errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('PANEL_WIDTH') + " <br>"
  } else {
    if (!CheckNumber(pwbQuotation.panelWidth)) {
      errorMessage = errorMessage + vueInstance.$t('PANEL_WIDTH') + vueInstance.$t('MUST_BE_INTEGER') + " <br>"
    } else if (Number(1219.2) < Number(pwbQuotation.panelWidth)) {
      errorMessage = errorMessage + vueInstance.$t('PANEL_WIDTH') + vueInstance.$t('MUST_SAMLL_THAN_SHEET_SIZE') + " <br>"
    }
  }
  if (!pwbQuotation.pnLength) {
    errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('PN_LENGTH') + " <br>"
  } else {
    if (!CheckNumber(pwbQuotation.pnLength)) {
      errorMessage = errorMessage + vueInstance.$t('PN_LENGTH') + vueInstance.$t('MUST_BE_INTEGER') + " <br>"
    } else if (Number(1219.2) < Number(pwbQuotation.pnLength)) {
      errorMessage = errorMessage + vueInstance.$t('PN_LENGTH') + vueInstance.$t('MUST_SAMLL_THAN_SHEET_SIZE') + " <br>"
    }
  }
  if (!pwbQuotation.pnWidth) {
    errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('PN_WIDTH') + " <br>"
  } else {
    if (!CheckNumber(pwbQuotation.pnWidth)) {
      errorMessage = errorMessage + vueInstance.$t('PN_WIDTH') + vueInstance.$t('MUST_BE_INTEGER') + " <br>"
    } else if (Number(1219.2) < Number(pwbQuotation.pnWidth)) {
      errorMessage = errorMessage + vueInstance.$t('PN_WIDTH') + vueInstance.$t('MUST_SAMLL_THAN_SHEET_SIZE') + " <br>"
    }
  }
  if (!pwbQuotation.pnInPanel) {
    errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('PN_IN_PANEL') + " <br>"
  } else {
    if (!CheckNumber(pwbQuotation.pnInPanel)) {
      errorMessage = errorMessage + vueInstance.$t('PN_IN_PANEL') + vueInstance.$t('MUST_BE_INTEGER') + " <br>"
    } else {
      if (Number(pwbQuotation.pnInPanel) < 0) {
        errorMessage = errorMessage + this.$t('PN_IN_PANEL') + this.$t('CAN_NOT_NEGATIVE') + " <br>"
      }
    }
  }
  if (pwbQuotation.panelLength && CheckNumber(pwbQuotation.panelLength) && pwbQuotation.pnLength && CheckNumber(pwbQuotation.pnLength)) {
    if (Number(pwbQuotation.panelLength) < Number(pwbQuotation.pnLength)) {
      errorMessage = errorMessage + vueInstance.$t('PN_LENGTH') + vueInstance.$t('MUST_SAMLL_THAN') + vueInstance.$t('PANEL_LENGTH') + " <br>"
    }
  }
  if (pwbQuotation.panelWidth && CheckNumber(pwbQuotation.panelWidth) && pwbQuotation.pnWidth && CheckNumber(pwbQuotation.pnWidth)) {
    if (Number(pwbQuotation.panelWidth) < Number(pwbQuotation.pnWidth)) {
      errorMessage = errorMessage + vueInstance.$t('PN_WIDTH') + vueInstance.$t('MUST_SAMLL_THAN') + vueInstance.$t('PANEL_WIDTH') + " <br>"
    }
  }
  return errorMessage
}

function buildCriteria(vueInstance) {
  return {
    'currency': vueInstance.quotation.currency,
    'price': vueInstance.pwbQuotation.deltaPnPrice,
    'supplierQuotationFiles': vueInstance.supplierQuotationFiles,
    'uuid': vueInstance.quotation.uuid,
    'category': 'PWB',
    'pwbQuotationRequestDto': {
      'deltaModel': vueInstance.pwbQuotation.deltaModel,
      'deltaExchangeRate': Number(vueInstance.deltaExchangeRate).toFixed(5),
      'cpcExchangeRate': Number(vueInstance.cpcExchangeRate),
      'rfqBase': vueInstance.pwbQuotation.rfqBase,
      'cclLaminateType': vueInstance.pwbQuotation.cclLaminateType,
      'layer': vueInstance.pwbQuotation.layer,
      'pcbThickness': vueInstance.pwbQuotation.pcbThickness,
      'internalCoreThickness': vueInstance.pwbQuotation.internalCoreThickness,
      'tg': vueInstance.pwbQuotation.tg,
      'externalCopperThickness': vueInstance.pwbQuotation.externalCopperThickness,
      'internalCopperThickness': vueInstance.pwbQuotation.internalCopperThickness,
      'mainSourceCclSupplierId': vueInstance.pwbQuotation.mainSourceCclSupplier ? vueInstance.pwbQuotation.mainSourceCclSupplier.uuid : null,
      'mainSourceCclShare': vueInstance.pwbQuotation.mainSourceCclShare,
      'mainCoreUlNumberId': vueInstance.pwbQuotation.mainCoreUlNumber ? vueInstance.pwbQuotation.mainCoreUlNumber.uuid : null,
      'mainCoreUP': Number(vueInstance.pwbQuotation.mainCoreUP),
      'secondSourceCclSupplierId': vueInstance.pwbQuotation.secondSourceCclSupplier ? vueInstance.pwbQuotation.secondSourceCclSupplier.uuid : null,
      'secondSourceCclShare': 100 - vueInstance.pwbQuotation.mainSourceCclShare,
      'secondCoreUlNumberId': vueInstance.pwbQuotation.secondCoreUlNumber ? vueInstance.pwbQuotation.secondCoreUlNumber.uuid : null,
      'secondCoreUP': Number(vueInstance.pwbQuotation.secondCoreUP),
      'pcbPrice': Number(vueInstance.pwbQuotation.pcbPrice),
      'panelLength': Number(vueInstance.pwbQuotation.panelLength),
      'panelWidth': Number(vueInstance.pwbQuotation.panelWidth),
      'pnLength': Number(vueInstance.pwbQuotation.pnLength),
      'pnWidth': Number(vueInstance.pwbQuotation.pnWidth),
      'area': Number(vueInstance.pwbQuotation.area),
      'pnArea': Number(vueInstance.pwbQuotation.pnArea),
      'pnCoreDivisionArea': Number(vueInstance.pwbQuotation.pnCoreDivisionArea),
      'innerCoreDivisionCclSheets': Number(vueInstance.pwbQuotation.innerCoreDivisionCclSheets),
      'supplierSheetSize': vueInstance.pwbQuotation.supplierSheetSize,
      'deltaSheetSize': vueInstance.pwbQuotation.deltaSheetSize,
      'pnInSheet': Number(vueInstance.pwbQuotation.pnInSheet),
      'pnInPanel': Number(vueInstance.pwbQuotation.pnInPanel),
      'panelSheet': vueInstance.pwbQuotation.panelSheet,
      'pnUtilization': Number(vueInstance.pwbQuotation.pnUtilization),
      'panelUtilization': Number(vueInstance.pwbQuotation.panelUtilization),
      'combineRatio': Number(vueInstance.pwbQuotation.combineRatio),
      'numberOfDrill': Number(vueInstance.pwbQuotation.numberOfDrill),
      'slotLength': Number(vueInstance.pwbQuotation.slotLength),
      'goldArea': Number(vueInstance.pwbQuotation.goldArea),
      'materialCost': Number(vueInstance.pwbQuotation.materialCost),
      'surfaceFinishCost': vueInstance.pwbQuotation.surfaceFinishCost,
      'processCost': vueInstance.pwbQuotation.processCost,
      'specialCostDown': Number(vueInstance.pwbQuotation.specialCostDown),
      'deltaPnPriceUsd': Number(vueInstance.pwbQuotation.deltaPnPriceUsd),
      'deltaPnPrice': Number(vueInstance.pwbQuotation.deltaPnPrice),
      'supplierRemark': vueInstance.pwbQuotation.supplierRemark,
      'pwbCostItems': vueInstance.processCostItems.concat(vueInstance.surfaceCostItems)
    }
  }
}
</script>
  
<style scoped></style>
  